/** Shell layout palette (3-tone: nav / page chrome / content surround). */
export const LAYOUT_NAV_BG = '#1e1e2d';
export const LAYOUT_SURFACE = '#ffffff';
export const LAYOUT_CONTENT_BG = '#eaecec';

/** Horizontal inset for main column, header, and footer (blank margin each side). */
export const LAYOUT_MAIN_GUTTER_PX = 20;

/** Space reserved above fixed footer (bar height + breathing room). */
export const LAYOUT_FOOTER_RESERVED_PX = 56;
